import { createContext, type FC, type ReactNode, useContext } from "react";

const ViewerJourneyContext = createContext(false);

export const useIsViewerJourney = () => useContext(ViewerJourneyContext);

export const ViewerJourneyProvider: FC<{ children: ReactNode }> = ({
	children,
}) => (
	<ViewerJourneyContext.Provider value={true}>
		{children}
	</ViewerJourneyContext.Provider>
);
